<!-- 关联经销商 -->
<template>
  <div class="worksheet-structure app-container">
    <div class="page-container account">
      <el-form :inline="true" :model="memberInfo" size="mini">
        <div v-if="resDataType === '1' || resDataType === '3'">
          <!--          经销商编号-->
          <el-form-item :label="$t('miMember.memberNo.id') + ':'">
            <el-input v-model.trim="memberInfo.memberNo" size="mini" />
          </el-form-item>
          <el-button :loading="doLoading" size="mini" icon="el-icon-search" plain type="primary" @click="memberSearch">
            {{ $t('operation.button.search') }}
          </el-button>
        </div>
        <el-card v-if="resDataType !== '4'">
          <div>
            <p>{{ $t('Actual.controller.number') }}: <span>{{ mainMemberNo }}</span></p>
            <p v-if="resDataType === '1' || resDataType === '3'">{{ $t('sysUser.userName') }}: <span>{{ memberName
                }}</span></p>
            <p>{{ }}</p>
          </div>
          <el-button v-if="resDataType === '1' || resDataType === '3'" :loading="doLoading" size="small" type="warning"
            @click="applyforBtn">{{ $t('Apply_association') }}</el-button>
        </el-card>
      </el-form>
      <div v-if="resDataType === '1'">
        <el-table :data="list" border fit highlight-current-row max-height="485">
          <!--   实控人编号   -->
          <el-table-column :label="$t('Actual.controller.number')" prop="mainMemberNo" align="center" />
          <!--   关联经销商   -->
          <el-table-column :label="$t('Association_memberNo')" prop="memberNo" align="center" />
          <!-- 审核状态 -->
          <el-table-column :label="$t('pd.checkstatus')" align="center">
            <template v-slot="{ row }">
              <span v-if="row.status === 0" style=" color: #e6a23c"> {{ $t('check.lonading') }} </span>
              <span v-else-if="row.status === 1" style="color: green"> {{ $lt(initDict.statusType, row.status) }}
              </span>
              <span v-else-if="row.status === 3" style="color: red"> {{ $lt(initDict.statusType, row.status) }}
              </span>
            </template>
          </el-table-column>
          <!-- 退回原因 -->
          <el-table-column :label="$t('fiBonusAppl.backReason')" prop="remark" align="center">
            <template v-slot="{ row }">
              {{ row.status === 1 ? '' : row.remark }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="resDataType === '2'">
        <el-table :data="list2" border fit highlight-current-row max-height="485">
          <!--   关联经销商   -->
          <el-table-column :label="$t('Association_memberNo')" prop="memberNo" align="center" />
        </el-table>
      </div>
      <div v-if="resDataType === '3' || resDataType === '4'">
        <el-table :data="list3and4" border fit highlight-current-row max-height="485">
          <!--   实控人编号   -->
          <el-table-column :label="$t('Actual.controller.number')" prop="mainMemberNo" align="center" />
          <!--   关联经销商   -->
          <el-table-column :label="$t('Association_memberNo')" prop="memberNo" align="center" />
          <!-- 审核状态 -->
          <el-table-column :label="$t('pd.checkstatus')" align="center">
            <template v-slot="{ row }">
              <span v-if="row.status === 0" style=" color: #e6a23c"> {{ $t('check.lonading') }} </span>
              <span v-else-if="row.status === 1" style="color: green"> {{ $lt(initDict.statusType, row.status) }}
              </span>
              <span v-else-if="row.status === 3" style="color: red"> {{ $lt(initDict.statusType, row.status) }}
              </span>
            </template>
          </el-table-column>
          <!-- 退回原因 -->
          <el-table-column :label="$t('fiBonusAppl.backReason')" prop="remark" align="center">
            <template v-slot="{ row }">
              {{ row.status === 1 ? '' : row.remark }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { miMemberInfoCheck } from "@/api/userInfo/userInfo"
import { decide, add, type1, type2, type3adn4 } from "@/api/rus/api"
export default {
  name: 'AssociationMember',
  data() {
    return {
      mainMemberNo: '',
      memberName: '',
      resDataType: '',
      doLoading: false,
      list: [],
      list2: [],
      list3and4: [],
      memberInfo: {
        memberNo: ''
      },
      initDict: {
        statusType: 'fi_ac_trans.type'
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    applyforBtn() {
      console.log(this.memberInfo.memberNo, 'this.memberInfo.memberNo');
      console.log(this.memberName, 'this.memberName');


      if (this.memberInfo.memberNo && this.memberName) {
        this.doLoading = true
        this.memberInfo.memberNo = this.memberInfo.memberNo.trim().toUpperCase()
        add({ 'code': this.memberInfo.memberNo, 'type': this.resDataType }).then(() => {
          this.$message.success(this.$t('success.operation'))
          this.getList()
          this.doLoading = false
        }).catch(() => {
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
          this.doLoading = false
        })
      }
    },
    getList() {
      decide().then(res => {
        this.resDataType = res.data
        switch (res.data) {
          case '1':
            this.list = []
            type1().then(res => {
              const { memberList, memberCheckList } = res.data
              let a = [...memberCheckList, ...memberList]
              if (memberList.length === 0 || memberCheckList.length === 0) {
                this.list = a
              } else {
                let result = [];
                for (let i = 0; i < a.length; i++) {
                  let flag = true;
                  for (let j = 0; j < result.length; j++) {
                    if (a[i].memberNo === result[j].memberNo) {
                      flag = false;
                    }
                  }
                  if (flag) {
                    result.push(a[i]);
                  }
                }
                this.list = result
              }
            })
            break
          case '2':
            type2().then(res => {
              this.list2 = res.data
              this.mainMemberNo = res.data[0].mainMemberNo
            })
            break
          case '3':
            break
          case '4':
            type3adn4().then(res => {
              this.list3and4 = res.data.records
            })
            break
          default:
            this.resDataType = ''
        }
      })
    },
    memberSearch() {
      if (!this.memberInfo.memberNo) {
        return false
      }
      this.memberInfo.memberNo = this.memberInfo.memberNo.toUpperCase()
      miMemberInfoCheck({ 'code': this.memberInfo.memberNo }).then(res => {
        this.mainMemberNo = res.data.mainMemberNo
        this.memberName = res.data.name
      }).catch(() => {
        this.memberName = ''
        this.mainMemberNo = ''
      })

    }
  }
}
</script>

<style scoped lang="scss">
.table-css {
  td {
    width: 150px;
  }
}

::v-deep .el-card__body {
  display: flex;
  justify-content: space-between
}
</style>
